export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export function formatTs(isoOrMs) {
  if (isoOrMs == null) return '—';
  const t = typeof isoOrMs === 'number' ? isoOrMs : Date.parse(isoOrMs);
  if (Number.isNaN(t)) return '—';
  return new Date(t).toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

export function formatLatency(ms) {
  if (ms == null || Number.isNaN(Number(ms))) return '—';
  return `${Math.round(Number(ms))} ms`;
}
